import './style.css';

// Subtle parallax on split halves
const halves = document.querySelectorAll<HTMLElement>('.landing-half');
for (const el of halves) {
  el.addEventListener('pointermove', (e) => {
    const r = el.getBoundingClientRect();
    const x = ((e.clientX - r.left) / r.width - 0.5) * 12;
    const y = ((e.clientY - r.top) / r.height - 0.5) * 12;
    el.style.setProperty('--mx', `${x}px`);
    el.style.setProperty('--my', `${y}px`);
  });
  el.addEventListener('pointerleave', () => {
    el.style.setProperty('--mx', '0px');
    el.style.setProperty('--my', '0px');
  });
}
